module.exports = __webpack_public_path__ + "img/134.8023ff01.jpg";